import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../config/app-config';

/** Configuración editable por cliente incluida en el ZIP web. */
@Injectable()
export class RuntimeAppConfigProvider {
  private readonly browserConfigPath = 'browser-config.json';

  constructor(private http: HttpClient) {}

  inicializar(): Promise<void> {
    return this.http.get(this.browserConfigPath + '?t=' + new Date().getTime())
      .toPromise()
      .then((configuracion: any) => {
        if (!configuracion || configuracion.activo !== true) { return; }
        const apiBaseUrl = this.normalizarApiBaseUrl(configuracion.apiBaseUrl);
        const license = this.normalizarLicense(configuracion.license);
        if (apiBaseUrl) { APP_CONFIG.apiBaseUrl = apiBaseUrl; }
        if (license) { APP_CONFIG.license = license; }
      })
      .catch(() => undefined);
  }

  private normalizarApiBaseUrl(value: any): string {
    if (typeof value !== 'string' || !value.trim()) { return ''; }
    const url = value.trim();
    if (!/^https?:\/\//i.test(url)) { return ''; }
    return url.replace(/\/+$/, '') + '/';
  }

  private normalizarLicense(value: any): string {
    return typeof value === 'string' ? value.trim() : '';
  }
}



// WEBPACK FOOTER //
// ./src/providers/runtime-app-config/runtime-app-config.ts